// extracted by mini-css-extract-plugin
export default {"section":"SearchEngine_section__hxHNe","sectionWithRange":"SearchEngine_sectionWithRange__I98Nd","range":"SearchEngine_range__U5HIe"};